import { useEffect, useState } from 'react';
import { useAuth } from '../../auth/Auth';
import { useModal } from '../../helpers/hooks/modalContext';
import { EquifaxSubscribedBuilding } from '../../helpers/utils/types';
import { getEquifaxSubscribedBuildings } from '../../auth/_requests';

const EnableReporting = () => {
  const { setModal, modalState } = useModal();
  const { auth } = useAuth();
  const openModal = () => {
    setModal('enable-reporting');
  };
  const page = 1;
  const limit = 10; // Adjust as needed
  const [subscribedBuildings, setSubscribedBuildings] = useState<EquifaxSubscribedBuilding[]>([]);
  const [loading, setLoading] = useState(false);
  const fetchSubscribedBuildings = async () => {
    setLoading(true);
    try {
      // Simulate API call
      const response = await getEquifaxSubscribedBuildings(auth?.data?.token, page, limit);
      setSubscribedBuildings(response.data);
    } catch (error) {
      console.error('Error fetching subscribed buildings:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Fetch subscribed buildings from API or context

    fetchSubscribedBuildings();
  }, []);

  useEffect(() => {
    if (modalState?.refreshEquifaxEligibleBuildings) {
      fetchSubscribedBuildings();
      setModal(null, {
        refreshEquifaxEligibleBuildings: false, // Reset the flag after refreshing
      });
    }
  }, [modalState]);
  if (loading) {
    return (
      <div>
        <div className='w-full flex justify-center items-center py-10'>
          <div className='animate-pulse flex space-x-4'>
            <div className='rounded-full bg-gray-200 h-10 w-10'></div>
            <div className='flex-1 space-y-4 py-1'>
              <div className='h-4 bg-gray-200 rounded w-3/4'></div>
              <div className='h-4 bg-gray-200 rounded'></div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className='relative w-full flex justify-center items-center'>
      <div className='absolute bottom-1 left-1/2 translate-x-[-50%] w-[80%] h-[60px] rounded-[20px] shadow-[0px_12px_50px_0px_#0055FF] z-0 pointer-events-none'></div>
      <div className='relative z-5 w-full flex-shrink-0 rounded-[20px] border-[2px] border-[#E9EDF9] bg-gradient-to-b from-white/0 to-[#D0D5E6]/60 bg-[#FDFEFF] shadow-[inset_0_12px_20px_0_#F0F2F9] px-[20px] py-[32px]'>
        <div className='flex flex-col items-center gap-5'>
          <span className='text-main text-center text-[22px] leading-normal tracking-[0.22px]'>
            We report your rent payments to major credit bureaus for <strong>free!</strong>
          </span>
          {subscribedBuildings.length === 0 ? (
            <button className='submitBtn w-[50%]' onClick={openModal}>
              Enable reporting
            </button>
          ) : (
            <button
              className='submitBtn w-[50%]'
              onClick={() =>
                setModal('view-equifax-details', {
                  equifaxSubscribedBuildings: subscribedBuildings,
                })
              }
            >
              View details
            </button>
          )}
          <span className='px-6 text-light/60 text-center font-normal leading-[18px] tracking-[0.14px]'>
            To start Credit Builder, user must have at least one property with an active recurring
            payment. Also, cannot subscribe again to any building that was previously unsubscribed
            from Credit Builder.
          </span>
        </div>
      </div>
    </div>
  );
};

export default EnableReporting;
